<template>
  <div>
    <CRUD
      v-if="editItem || deleteItem"
      :edit-item="editItem"
      :delete-item="deleteItem"
      @edited="onCloseEdit"
      @deleted="onCloseDel"
    ></CRUD>
    <v-card v-else-if="item" class="mx-auto" outlined>
      <v-card-title class="justify-center">
        <span class="headline">{{ item.name }}</span>
      </v-card-title>
      <v-card-subtitle class="text-center">
        <span class="text-center">{{ item.broker }} @ {{item.loginId}}</span>
      </v-card-subtitle>

      <v-card-text>
        <v-list-item-title class="text-center display-3">{{ item.balance }}</v-list-item-title>

        <v-list class="transparent" dense>
          <!-- <v-list-item>
            <v-list-item-subtitle class="text-left">Traders</v-list-item-subtitle>

            <v-list-item-title class="text-center">1 : 100</v-list-item-title>

            <v-list-item-subtitle class="text-right">Investors</v-list-item-subtitle>
          </v-list-item>-->
          <v-list-item>
            <v-list-item-subtitle class="text-left">Private</v-list-item-subtitle>

            <v-list-item-title class="text-center">{{ item.invisible }} : {{ item.allowSubscribe }}</v-list-item-title>

            <v-list-item-subtitle class="text-right">Allow Copy</v-list-item-subtitle>
          </v-list-item>
          <v-list-item>
            <v-list-item-subtitle class="text-left">Enable</v-list-item-subtitle>

            <v-list-item-title class="text-center">{{ item.enable }} : {{ item.live }}</v-list-item-title>

            <v-list-item-subtitle class="text-right">Live</v-list-item-subtitle>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-divider />
      <miniProfile :user="getUser(item)" />
      <v-divider />
      <v-card-actions>
        <v-btn color="primary" text @click="accountDetail(item)">
          <v-icon left>center_focus_weak</v-icon>DETAILS
        </v-btn>
        <v-spacer></v-spacer>
        <v-menu v-if="item.user && item.user.id === currentUser.uid" top left>
          <template v-slot:activator="{ on }">
            <v-btn color="primary" icon v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list dense>
            <v-list-item-group>
              <v-list-item @click="onEdit(item)">
                <v-list-item-icon>
                  <v-icon>edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Edit</v-list-item-title>
              </v-list-item>
              <v-divider />
              <v-list-item @click="onDelete(item)">
                <v-list-item-icon>
                  <v-icon>delete</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Delete</v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { USER } from "@/store/actions.type";
import { mapGetters } from "vuex";
import CRUD from "@/components/accounts/CRUD.vue";
import miniProfile from "@/components/users/miniProfile.vue";
export default {
  name: "AccountCard",
  components: {
    CRUD,
    miniProfile
  },
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      subscribe: {
        traderAccountId: null
      },
      editItem: null,
      deleteItem: null
    };
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  // watch: {
  //   // this.$store.dispatch(TRADER.PETCH);
  //   currentUser: function(user) {
  //     if (this.item.userId == user.id) {
  //       this.item.user = user;
  //     } else {
  //       this.$store.dispatch(USER.GETBASIC, this.item.userId).then(userinfo => {
  //         this.item.user = userinfo;
  //       });
  //     }
  //   }
  // },
  methods: {
    onEdit(item) {
      this.editItem = item.account;
    },
    onDelete(item) {
      this.deleteItem = item.account;
    },
    onCloseEdit() {
      this.editItem = null;
    },
    onCloseDel() {
      this.deleteItem = null;
    },
    onSubscribe(item) {
      if (this.subscribe.traderAccountId != item.id) {
        this.subscribe.traderAccountId = item.id;
      } else {
        this.subscribe.traderAccountId = null;
      }
    },
    accountDetail(item) {
      // return this.$router.push("accounts/" + id);
      this.$emit("onSelect", item);
    },
    getUser(account) {
      if (account.userId == this.currentUser.id) {
        return this.currentUser;
      } else {
        this.$store.dispatch(USER.GETBASIC, account.userId).then(user => {
          return user;
        });
      }
    }
  }
};
</script>
<style></style>
